import { FileReader, FileWriter } from '@/platform'
import { describeEvent } from '@/control/eventDescriptionDescribe'
import EventID from './EventID'
import { normalizeString } from '../gameBinUtils'

class EventBase{

    /**
     * 所属剧情的id
     */
    mapId:string = "-1"

    /**
     * 事件子类名
     */
    public eventClassName: string = 'EventBase'

    /// region 需写入byte的属性，关键属性
    /// <summary>
    /// 事件ID
    /// </summary>
    public Code: EventID = -1

    /// <summary>
    /// 指令的参数本体
    /// </summary>
    public Parameter: Array<string> = new Array()

    /// <summary>
    /// 事件的深度，没有字段只有属性，直接用吧
    /// </summary>
    public Indent: number = 0
    /// endregion

    /// <summary>
    /// 事件参数长度（项数）
    /// </summary>
    public EventLength: number = 0

    /// <summary>
    /// 是否折叠（存储的值为0或1或2....）
    /// </summary>
    public isFold: number = 0

    /// <summary>
    /// 上一级分歧项的折叠情况
    /// </summary>
    public SeniorFold: boolean = false

    /// <summary>
    /// 折叠的深度
    /// </summary>
    public FoldIndent: number = 0

    /**
     * 事件列表展示文案（与 docs/ue/事件描述信息.md 中 C# GetDescriptionContent 一致，见 control/eventDescriptionDescribe.ts）。
     */
    public content(): string {
        return describeEvent(this)
    }

    showFormat:string = ""

    /**
     * 语言索引化的参数
     */
    protected localesParams:number[] = []

    curKeyIndex = 0

    /**
     * 临时语言
     */
    public tempLang: string = ""

    /**
     * 旧事件类仍会声明本地化参数位，轻量版先只保留索引记录。
     */
    public setLocalesParam(indexes: number[]): void {
        this.localesParams = [...indexes]
    }

    constructor(reader?: FileReader) {
        if (reader) {
            this.readBin(reader)
        }
    }

    /** 与 cg_v3_data EventBase.writeBin / projects.bin 读取流程一致 */
    readBin(reader: FileReader): void {
        this.Parameter = []
        this.Code = reader.readInt()
        const plen = reader.readInt()
        this.Parameter.length = plen
        for (let i = 0; i < plen; i++) {
            this.Parameter[i] = reader.readString()
        }
        this.Indent = reader.readInt()
        this.EventLength = reader.readInt()
        this.isFold = reader.readInt()
        this.SeniorFold = reader.readBool()
        this.FoldIndent = reader.readInt()
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.Code)
        writer.writeInt(this.Parameter.length)
        for (let i = 0; i < this.Parameter.length; i++) {
            writer.writeString(this.Parameter[i] ?? '')
        }
        writer.writeInt(this.Indent)
        writer.writeInt(this.EventLength)
        writer.writeInt(this.isFold)
        writer.writeBool(this.SeniorFold)
        writer.writeInt(this.FoldIndent)
    }

    readVersionedOui(reader: FileReader): void {
        this.Code = reader.readInt()
        this.Indent = reader.readInt()

        this.isFold = reader.readInt()
        this.FoldIndent = reader.readInt()
        this.SeniorFold = reader.readInt() ? true : false

        this.EventLength = reader.readInt()
        for (var i = 0; i < this.EventLength; i++) {
            this.Parameter.push(reader.readString())
        }
    }

    // 数据写入
    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.Code)
        writer.writeInt(this.Indent)

        writer.writeInt(this.isFold)
        writer.writeInt(this.FoldIndent)
        writer.writeInt(this.SeniorFold ? 1 : 0)

        writer.writeInt(this.Parameter.length)
        for (var i = 0; i < this.Parameter.length; i++) {
            writer.writeString(this.Parameter[i])
        }

        writer.writerLength()
    }

    /**
     * 运行时脚本只把 `\n` 指令解析为换行，工程编辑态的真实换行需在导出 Game.bin 时转换。
     */
    private getGameBinParameter(index: number): string {
        const value = normalizeString(this.Parameter[index])
        if (
            (this.Code === EventID.Text && index === 2)
            || (this.Code === EventID.String && index === 1)
        ) {
            return value.replace(/\r\n|\r|\n/g, '\\n')
        }
        return value
    }

    writeGameBin(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeInt(this.Code)
        writer.writeInt(this.Indent)
        writer.writeInt(this.Parameter.length)
        for (let i = 0; i < this.Parameter.length; i++) {
            writer.writeString(this.getGameBinParameter(i))
        }
        writer.writerLength()
    }
} 
export default EventBase
